import React from 'react';
import Carousel from '../Carousel';
import { useSelector } from 'react-redux';
import './NavigationTabs.scss';
import SwiperComp from '../Swiper';
const dataEn = [
  {
    id: 1,
    name: 'About Us',
    url: '/about-us',
    locale: 'en',
  },
  {
    id: 2,
    name: 'Privacy Policy',
    url: '/disclaimer',
    locale: 'en',
  },
  {
    id: 3,
    name: 'Terms & Conditions',
    url: '/terms',
    locale: 'en',
  },
  {
    id: 4,
    name: 'Customer Rights & Responsibilities',
    url: '/rights-and-responsibilities',
    locale: 'en',
  },
  {
    id: 5,
    name: 'Careers',
    url: '/careers',
    locale: 'en',
  },
];
const dataAr = [
  {
    id: 1,
    name: 'معلومات عنا',
    url: '/about-us',
    locale: 'ar',
  },
  {
    id: 2,
    name: 'سياسة الخصوصية',
    url: '/disclaimer',
    locale: 'ar',
  },
  {
    id: 3,
    name: 'الأحكام والشروط',
    url: '/terms',
    locale: 'ar',
  },
  {
    id: 4,
    name: 'حقوق ومسؤوليات العميل',
    url: '/rights-and-responsibilities',
    locale: 'ar',
  },
  {
    id: 5,
    name: 'وظائف',
    url: '/careers',
    locale: 'ar',
  },
];
const NavigationTabs = () => {
  const { iso } = useSelector((state) => state.layout);

  let direction = iso === 'en' ? 'ltr' : 'rtl';
  return (
    <div className="NavigationTabs">
      <div className="filterItems container">
        {/* <Carousel
          id={`filterItems${1}`}
          large={5}
          mid={3}
          small={2}
          show_dots={false}
          direction={direction}
          initial_shift={0}
          type="SildeBundleFilter"
          show_next_prev_buttons={false}
          slides={iso === 'en' ? dataEn : dataAr}
          autoRotate={false}
          speed={6000}
        /> */}
        <SwiperComp
          slides={iso === 'en' ? dataEn : dataAr}
          type={'static-pages'}
        />
      </div>
    </div>
  );
};

export default NavigationTabs;
